<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-92" @click="goBack()">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Job Details</ion-title>

    </ion-toolbar>
    <div class="main_wrapper ion-padding">
        <div class="container">

            <div class="job-detail-header">
                <div class="image_wrapper" data-testid="directions-64" @click="userInfoModalOpen(job.jobPharmacy)">
                    <el-avatar :size="'small'" shape="square" :src="job.jobPost.pharmacy.image"
                        v-if="job.jobPost.pharmacy.image" />
                    <el-avatar :size="'small'" class="avatar-job" shape="square"
                        icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
                </div>
                <div class="job-detail-header-row">
                    <div class="job-detail-header-row-left">
                        <div class="job-title">{{ job.jobPost.title }}</div>
                        <div class="job-poster">{{ job.jobPost.pharmacy.name }}</div>
                    </div>
                    <el-tag class="inverted">
                        Published {{ job.jobPost.publishedDate }}
                    </el-tag>
                </div>

                <div class="preview-section">
                    <div class="preview-section__header">
                        <div class="preview-section__title">
                            Job Details
                        </div>
                    </div>
                    <p v-html="displayedText" class="job-description"></p>
                    <el-button class="text-only" @click="toggleView"  v-if="isShowMoreJD"> {{ state.isTruncated ? 'View More' : 'View Less' }}</el-button>
                </div>

                <div class="separator"></div>
                <div class="preview-section">
                   
                    <div class="detail-item">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.3332 9.99984C18.3332 14.5998 14.5998 18.3332 9.99984 18.3332C5.39984 18.3332 1.6665 14.5998 1.6665 9.99984C1.6665 5.39984 5.39984 1.6665 9.99984 1.6665C14.5998 1.6665 18.3332 5.39984 18.3332 9.99984Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M13.0919 12.65L10.5086 11.1083C10.0586 10.8416 9.69189 10.2 9.69189 9.67497V6.2583"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </div>
                        <div class="detail-item__value">{{ job.jobPost.type }}</div>
                    </div>
                    <div class="detail-item" v-if="!job.jobPost.hideSalary">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.22656 11.9417C7.22656 13.0167 8.05156 13.8834 9.07656 13.8834H11.1682C12.0599 13.8834 12.7849 13.125 12.7849 12.1917C12.7849 11.175 12.3432 10.8167 11.6849 10.5834L8.32656 9.4167C7.66823 9.18337 7.22656 8.82503 7.22656 7.80837C7.22656 6.87503 7.95156 6.1167 8.84323 6.1167H10.9349C11.9599 6.1167 12.7849 6.98337 12.7849 8.05837"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 5V15" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>


                        </div>
                        <div class="detail-item__value">{{ job.jobPost.payInterval }} Rate: {{ job.jobPost.payRate }}
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                                <path
                                    d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                            </svg>

                        </div>
                        <div class="detail-item__value">{{ job.jobPost.location }}</div>
                    </div>
                </div>

                <div class="separator" v-if="job.jobPost.selectedJobPostSkills.length > 0"></div>
                <div class="preview-section" v-if="job.jobPost.selectedJobPostSkills.length > 0">
                    <div class="preview-section__header">
                        <div class="preview-section__title">
                            Skills
                        </div>
                    </div>

                    <div class="skill-list-pills">
                        <div v-for="skill in job.jobPost.selectedJobPostSkills" :key="skill.id">
                            <el-tag class="inverted pill">{{ skill.name }}</el-tag>
                        </div>
                    </div>
                </div>

                <div class="separator" v-if="job.jobPost.pharmacy.scripts.length > 0"></div>
                <div class="preview-section" v-if="job.jobPost.pharmacy.scripts.length > 0">
                    <div class="preview-section__header">
                        <div class="preview-section__title">
                            Other Details
                        </div>
                    </div>

                    <div v-if="job.jobPost.pharmacy.scripts.length > 0" class="job-scripts">
                        <div class="detail-item" v-for="(item, key) in job.jobPost.pharmacy.scripts" :key="key">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.6665 10.1665H12.4998" stroke="rgb(var(--locumate-primary-color-dark))"
                                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M6.6665 13.5H10.3165" stroke="rgb(var(--locumate-primary-color-dark))"
                                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.33317 4.99984H11.6665C13.3332 4.99984 13.3332 4.1665 13.3332 3.33317C13.3332 1.6665 12.4998 1.6665 11.6665 1.6665H8.33317C7.49984 1.6665 6.6665 1.6665 6.6665 3.33317C6.6665 4.99984 7.49984 4.99984 8.33317 4.99984Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__content">
                                <div class="detail-item__topic">
                                    Average script per day {{ key === 'weekdays' ? '(' + key + ')' : key }}
                                </div>
                                <div class="detail-item__value">{{ item }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detail-item">
                        <div class="detail-item__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.66685 18.3333H13.3335C16.6835 18.3333 17.2835 16.9917 17.4585 15.3583L18.0835 8.69167C18.3085 6.65833 17.7252 5 14.1668 5H5.83351C2.27518 5 1.69185 6.65833 1.91685 8.69167L2.54185 15.3583C2.71685 16.9917 3.31685 18.3333 6.66685 18.3333Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M6.6665 4.99984V4.33317C6.6665 2.85817 6.6665 1.6665 9.33317 1.6665H10.6665C13.3332 1.6665 13.3332 2.85817 13.3332 4.33317V4.99984"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M11.6668 10.8333V11.6667C11.6668 11.675 11.6668 11.675 11.6668 11.6833C11.6668 12.5917 11.6585 13.3333 10.0002 13.3333C8.35016 13.3333 8.3335 12.6 8.3335 11.6917V10.8333C8.3335 10 8.3335 10 9.16683 10H10.8335C11.6668 10 11.6668 10 11.6668 10.8333Z"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18.0415 9.1665C16.1165 10.5665 13.9165 11.3998 11.6665 11.6832"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2.18311 9.3916C4.05811 10.6749 6.17477 11.4499 8.33311 11.6916"
                                    stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </div>
                        <div class="detail-item__content">
                            <div class="detail-item__topic">
                                Dispensing Software
                            </div>
                            <div class="detail-item__value">
                                    {{ job.jobPost.pharmacy.software }}<span v-if="job.jobPost.pharmacy.software === 'Other'">: {{ job.jobPost.pharmacy.softwareOther }}</span>
                                </div>
                        </div>
                    </div>
                </div>


                <div v-if="job.jobPost.pharmacy.services.length > 0">
                    <div class="separator"></div>
                    <div class="preview-section">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Services
                            </div>
                        </div>
                        <div class="detail-item" v-for="(item, key) in job.jobPost.pharmacy.services" :key="key">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.49984 18.3332H12.4998C16.6665 18.3332 18.3332 16.6665 18.3332 12.4998V7.49984C18.3332 3.33317 16.6665 1.6665 12.4998 1.6665H7.49984C3.33317 1.6665 1.6665 3.33317 1.6665 7.49984V12.4998C1.6665 16.6665 3.33317 18.3332 7.49984 18.3332Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.4585 9.99993L8.81683 12.3583L13.5418 7.6416"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__value">{{ item }}</div>
                        </div>
                    </div>
                </div>

                <div class="info_wrapper services" v-if="job?.jobPost?.pharmacy?.settings?.additionalEmail1">
                    <div class="separator"></div>
                    <div class="info_value">
                        <div class="preview-section__header">
                                        <div class="preview-section__title">
                                            Pharmacy Contacts
                                        </div>
                                    </div>
                        <div class="pharmacy-contacts">
                        <div v-if="job?.jobPost?.pharmacy?.settings?.additionalName1" class="d-flex gap-3 align-items-center w-full">

                            <div class="user-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.0006 22.75H9.00063C7.68063 22.75 6.58063 22.62 5.65063 22.34C5.31063 22.24 5.09063 21.91 5.11063 21.56C5.36063 18.57 8.39063 16.22 12.0006 16.22C15.6106 16.22 18.6306 18.56 18.8906 21.56C18.9206 21.92 18.7006 22.24 18.3506 22.34C17.4206 22.62 16.3206 22.75 15.0006 22.75ZM6.72063 21.06C7.38063 21.19 8.13063 21.25 9.00063 21.25H15.0006C15.8706 21.25 16.6206 21.19 17.2806 21.06C16.7506 19.14 14.5606 17.72 12.0006 17.72C9.44063 17.72 7.25063 19.14 6.72063 21.06Z" fill="rgb(var(--locumate-clr-gray-light))"/>
                                <path d="M15 2H9C4 2 2 4 2 9V15C2 18.78 3.14 20.85 5.86 21.62C6.08 19.02 8.75 16.97 12 16.97C15.25 16.97 17.92 19.02 18.14 21.62C20.86 20.85 22 18.78 22 15V9C22 4 20 2 15 2ZM12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z" stroke="rgb(var(--locumate-clr-gray-light))" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.9999 14.92C9.60992 14.92 7.66992 12.97 7.66992 10.58C7.66992 8.19002 9.60992 6.25 11.9999 6.25C14.3899 6.25 16.3299 8.19002 16.3299 10.58C16.3299 12.97 14.3899 14.92 11.9999 14.92ZM11.9999 7.75C10.4399 7.75 9.16992 9.02002 9.16992 10.58C9.16992 12.15 10.4399 13.42 11.9999 13.42C13.5599 13.42 14.8299 12.15 14.8299 10.58C14.8299 9.02002 13.5599 7.75 11.9999 7.75Z" fill="rgb(var(--locumate-clr-gray-light))"/>
                                </svg>
                            </div>
                            <div class="pharmacy-contact-details">
                            <span class="value pharmacy-contact-name">{{ job?.jobPost?.pharmacy?.settings?.additionalName1 }}
                            </span>
                            <!-- <span class="value">{{ job?.jobPost?.pharmacy?.settings?.additionalPhone1 }} </span> -->
                            <!-- <span class="value">{{ job?.jobPost?.pharmacy?.settings?.additionalEmail1 }} </span> -->
                            </div>
                            <div class="d-flex ml-auto flex-wrap contact-options">
                            <div class="d-flex gap-1 align-items-center pl-2">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.2875 11.2125L6.9 12.6C6.6075 12.8925 6.1425 12.8925 5.8425 12.6075C5.76 12.525 5.6775 12.45 5.595 12.3675C4.8225 11.5875 4.125 10.77 3.5025 9.915C2.8875 9.06 2.3925 8.205 2.0325 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.1225 9.99 8.205 10.065 8.28 10.14C8.58 10.4325 8.5875 10.9125 8.2875 11.2125Z"
                                    fill="#00B7AF" />
                                <path
                                    d="M16.4776 13.7468C16.4776 13.9568 16.4401 14.1743 16.3651 14.3843C16.3426 14.4443 16.3201 14.5043 16.2901 14.5643C16.1626 14.8343 15.9976 15.0893 15.7801 15.3293C15.4126 15.7343 15.0076 16.0268 14.5501 16.2143C14.5426 16.2143 14.5351 16.2218 14.5276 16.2218C14.0851 16.4018 13.6051 16.4993 13.0876 16.4993C12.3226 16.4993 11.5051 16.3193 10.6426 15.9518C9.78007 15.5843 8.91757 15.0893 8.06257 14.4668C7.77007 14.2493 7.47757 14.0318 7.20007 13.7993L9.65257 11.3468C9.86257 11.5043 10.0501 11.6243 10.2076 11.7068C10.2451 11.7218 10.2901 11.7443 10.3426 11.7668C10.4026 11.7893 10.4626 11.7968 10.5301 11.7968C10.6576 11.7968 10.7551 11.7518 10.8376 11.6693L11.4076 11.1068C11.5951 10.9193 11.7751 10.7768 11.9476 10.6868C12.1201 10.5818 12.2926 10.5293 12.4801 10.5293C12.6226 10.5293 12.7726 10.5593 12.9376 10.6268C13.1026 10.6943 13.2751 10.7918 13.4626 10.9193L15.9451 12.6818C16.1401 12.8168 16.2751 12.9743 16.3576 13.1618C16.4326 13.3493 16.4776 13.5368 16.4776 13.7468Z"
                                    fill="#00B7AF" />
                                </svg>

                                <span class="value">{{ job?.jobPost?.pharmacy?.settings?.additionalPhone1 }} </span>
                            </div>
                            <div class="d-flex gap-1 align-items-center pl-2">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.5 6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375H5.25"
                                    stroke="#00B7AF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75" stroke="#00B7AF"
                                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1.5 12.375H6" stroke="#00B7AF" stroke-width="1.5" stroke-miterlimit="10"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1.5 9.375H3.75" stroke="#00B7AF" stroke-width="1.5" stroke-miterlimit="10"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <span class="value">{{ job?.jobPost?.pharmacy?.settings?.additionalEmail1 }} </span>
                            </div>
                            </div>
                        </div>

                        </div>
                    </div>
                    </div>

            </div>
            <div class="apply-btn">
                <el-button class="submit" type="blue" data-testid="directions-93"
                    @click="withdrawApplication(job.id)">Withdraw Application</el-button>
            </div>
        </div>
        <!-- el-dialog -->


    </div>
    <modal-user-application-info :modalName="'userApplicationInfoModal'"
        :options="userApplicationInfoModal"></modal-user-application-info>
</template>

<script>
import {
    useRouter, useRoute
} from "vue-router";
import { onMounted, inject, ref, onBeforeMount, computed,reactive } from 'vue';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
addIcons({
    'arrow-back-outline': arrowBackOutline,
});
import { IonToolbar, IonButton, } from '@ionic/vue';

import { useStore } from "vuex";
import { PharmacyInfoModal } from "@/modals/modals";
export default {
    components: {
        IonToolbar,
        IonButton,
        "modal-user-application-info": PharmacyInfoModal,
    },
    setup() {
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject('setPageClassGlobal');
        const selectedOption = ref(null);
        const $store = useStore();
        const currentRouteName = ref(null);
        const $modals = inject("$modals");
        const state = reactive({
            isTruncated: true
        });
        const job = ref(
            {
                id: 1,
                title: 'Full time Pharmacy Assistant',
                pharmacy: {
                    name: 'Malvern Corner Pharmacy',
                    address: {
                        street: '123 Fake St',
                        city: 'Melbourne',
                        state: 'VIC',
                        postcode: '3000',
                    }
                },
                job_category: 'Pharmacy (Healthcare & Medical)',
                job_type: 'Full Time',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam quis aliquam ultricies, nisl nunc aliquet enim, vitae aliquam nisl nunc vitae nisl. Sed euismod, diam quis aliquam ultricies, nisl nunc aliquet enim, vitae aliquam nisl nunc vitae nisl.',
            }
        );

        const jobId = computed(() => $route.params.jobId);

        const goBack = () => {

            $router.push({
                name: "job_seeker_index",
            });

        };

        const toggleView = () => {
            state.isTruncated = !state.isTruncated;
        };

        const getClass = (status) => {
            // Convert the status to lowercase for case-insensitive comparison
            const lowercaseStatus = status.toLowerCase();

            // Return class based on status
            return lowercaseStatus;
        };

        const withdrawApplication = async (applicationId) => {

            try {
                await ElMessageBox.confirm(
                    `Are you sure you want to withdraw your application?`,
                    "Withdraw Application",
                    {
                        confirmButtonText: "Withdraw",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "danger",
                        cancelButtonClass: "secondary",
                        showClose: false,
                    }
                );

                await (async () => {
                    try {
                        const response = await $store.dispatch("WITHDRAW_JOB_APPLICATION", {
                            applicationId: applicationId,
                        });


                        if (response.data.success) {
                            ElMessage({
                                type: "success",
                                message: response.data.message,
                            });
                        } else {
                            ElMessage({
                                type: "info",
                                message: response.data.message,
                            });
                        }

                        currentRouteName.value = $router.currentRoute.value.name;
                        console.log("🚀 ~ await ~ currentRouteName.value:", currentRouteName.value)
                        $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

                        $router.push({
                            name: "job_seeker_index",
                        });

                    } catch (error) {
                        ElMessage({
                            type: "error",
                            message: error.message,
                        });
                        console.log("error submit!!");
                    }
                })();
            } catch (error) {
                console.log(error);
            }
        }



        const handleConfirm = () => {
            // Handle confirmation logic
            console.log('Selected option:', selectedOption.value);

        };


        const displayedText = computed(() => {
            const original = job.value.jobPost.description;
            if (state.isTruncated && original && original.split(' ').length > 50) {
                return original.split(' ').slice(0, 50).join(' ') + '...';
            } else {
                return original;
            }
        });


        const isShowMoreJD = computed(() => {
            const jobDescription = job.value.jobPost.description || '';
            return jobDescription.split(' ').length > 50;
        });


        const userApplicationInfoModal = ref({
            name: "userInfo",
            user: {},
        });
        const userApplicationsInfoModalOpen = (user) => {
            if (user) {
                userApplicationInfoModal.value.user = user;
            }
            $modals.open("userApplicationInfoModal");
        };

        onMounted(() => {
            setPageClassGlobal('global_job_poster_page');
        });

        onBeforeMount(async () => {
            try {
                // Dispatch first action
                const jobPostResponse = await $store.dispatch("JOB_SEEKER_APPLICATION_DETAILS_WITHDRAW", {
                    jobId: jobId.value,
                    params: {
                        with: "jobPost,jobPost.pharmacy",
                    },
                });

                job.value = jobPostResponse.data;
                console.log("🚀 ~ onBeforeMount ~ job:", job)

            } catch (error) {
                console.error("Error occurred:", error);
            }
        });

        return {
            goBack,
            job,
            withdrawApplication,
            jobId,
            getClass,
            handleConfirm,
            userApplicationInfoModal,
            userApplicationsInfoModalOpen,
            displayedText,
            toggleView,
            state,
            isShowMoreJD
        };
    },
};
</script>
